// extracted by mini-css-extract-plugin
export default {"plusButton":"plusButton__PlusButton__4qYez"};